export default "__VITE_ASSET__38aedf59__"